import styled from 'styled-components';

export const Container = styled.div<{
  $bgColor: string;
}>`
  background-color: #${(props) => props.$bgColor};
  padding: 8px 16px;
  border-radius: 8px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 16px;
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
`;

export const LeftContent = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
`;

export const TextContainer = styled.div<{ $color: string }>`
  display: flex;
  flex-direction: column;
  gap: 4px;
  color: ${(props) => props.$color};
  font-size: 14px;
  
  & span {
    font-weight: 600;
  }

  & p {
    font-weight: 500;
  }
`;
